// Author YuJiaBei
// Date 2021-09-08 11:21:38

import * as model from "@/model/sithMes/mst/SithMesMstLocationModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesMstLocation(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_MST_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'sithMesMstLocation',
        modelFilter: model.filter
    })
    .buildStore()
